import {Field, Label} from "../ui-components/fieldset.tsx";
import {Select} from "../ui-components/select.tsx";
import {Text} from "../ui-components/text.tsx";
import {FC, memo} from "react";
import {FieldConfig, FieldInputProps, useField} from "formik";
import {useTranslation} from "react-i18next";

type ArrayOfValuesType = {
    value: string | number
    title: string
    index: number
}
type CustomSelectType = {
    title?: string
    subTitle?: string
    arr: Array<ArrayOfValuesType>
    existLabel?: boolean
    existNotChoosen?: boolean
    formikValue: string
    getFieldProps: <Value = any>(props: string | FieldConfig<Value>) => FieldInputProps<Value>;
}

export const CustomSelect: FC<CustomSelectType> = memo(({
                                                            title,
                                                            subTitle,
                                                            formikValue,
                                                            getFieldProps, existNotChoosen,
                                                            existLabel,
                                                            arr
                                                        }) => {
    const [, meta] = useField(formikValue);
    const field = getFieldProps(formikValue);
    const hasError = meta.touched && meta.error;
    const {t} = useTranslation()

    return (

        <Field className={"w-full"}>
            {existLabel ? <Label
                className={"text-[var(--text-color-dark)] text-[14px] leading-[20px] pb-[4px] block !font-semibold"}>
                {title}
            </Label> : ''}
            <Select  {...field}
                     name={formikValue}
                     className={"!mt-0 [&>select]:py-[7px] [&>select]:!bg-white [&>select]:!border-none [&>select]:px-3 [&>span]:right-[0] border border-[var(--btn-border-custom)] rounded-lg shadow-xs [&>select]:!text-sm text-[var(--text-color-dark)]"}>
                <option value="" selected={!field.value} disabled>
                    {t('common.choose')}
                </option>
                {
                    existNotChoosen ? <option value="" selected={!field.value}>
                        {t('common.notChoosen')}
                    </option> : ''
                }

                {
                    arr.map(item => {
                        return (
                            <option value={item.value} key={item.index}>{item.title}</option>
                        )
                    })
                }
            </Select>
            {hasError && (
                <div className="text-red-500 text-sm mt-1">{meta.error}</div>
            )}
            {
                subTitle && !hasError && <Text className="!text-sm text-[var(--color-secondary)] mt-2">{subTitle}</Text>
            }
        </Field>
    )
})